import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface Baseline {
  id: string;
  name: string;
  scope: string;
  user_id: string | null;
  created_at: string;
  snapshot: Record<string, number>;
}

export function useAdminBaselines() {
  return useQuery<Baseline[]>({
    queryKey: ["admin", "baselines"],
    queryFn: () => apiClient.get("api/admin/baselines").json(),
    retry: false,
  });
}

export function useCreateBaseline() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; scope?: string; user_id?: string }) =>
      apiClient.post("api/admin/baselines", { json: body }).json(),
    onSettled: () => qc.invalidateQueries({ queryKey: ["admin", "baselines"] }),
  });
}

export function useDeleteBaseline() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiClient.delete(`api/admin/baselines/${id}`).json(),
    onSettled: () => qc.invalidateQueries({ queryKey: ["admin", "baselines"] }),
  });
}
